<template>
  <div>
    <el-card class="box-card">
      <div slot="header">查询条件</div>
      <el-form :inline="true" :model="conditions">
        <el-form-item>
          <el-input v-model="conditions.couponId" placeholder="优惠券ID" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="conditions.tel" placeholder="手机号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_query">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header">优惠券领取记录</div>
      <el-table :data="list" border stripe>
        <el-table-column prop="logId" label="记录ID" align="center" width="180" />
        <el-table-column prop="couponId" label="券ID" align="center" width="180" />
        <el-table-column prop="userCouponId" label="用户券ID" align="center" width="180" />
        <el-table-column prop="userId" label="用户ID" align="center" width="180" />
        <el-table-column prop="tel" label="手机号" align="center" width="120" />
        <el-table-column prop="communityId" label="小区ID" align="center" width="180" />
        <el-table-column prop="createTime" label="领取时间" align="center" min-width="160" />
      </el-table>
      <el-pagination
        style="margin-top:16px"
        :current-page="conditions.page"
        :page-size="conditions.row"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="_pageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { listMallCouponReceiveLog } from '@/api/market/mallCouponApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'MallCouponReceiveLog',
  data() {
    return {
      list: [],
      total: 0,
      conditions: { shopId: '', couponId: '', tel: '', page: 1, row: 10 }
    }
  },
  created() {
    this._init()
  },
  methods: {
    async _init() {
      this.conditions.shopId = await getShopId()
      this._query()
    },
    async _query() {
      this.conditions.shopId = await getShopId()
      const res = await listMallCouponReceiveLog(this.conditions)
      this.list = res.data || []
      this.total = res.total || 0
    },
    _pageChange(page) {
      this.conditions.page = page
      this._query()
    }
  }
}
</script>
